import React from 'react';
import { MagneticButton } from '../common/MagneticButton';

export const GrandFinale: React.FC = () => {
  return (
    <section className="relative py-28 sm:py-36 px-4 sm:px-6 z-10 bg-carbon-900 text-alabaster-100 overflow-hidden">
      <div className="max-w-5xl mx-auto text-center relative z-20 space-y-8">
        <div className="inline-flex items-center gap-2 px-3 py-1 bg-white/10 border border-white/20 text-chlorophyll-light font-mono text-[10px] tracking-widest uppercase">
          <span className="w-1.5 h-1.5 rounded-full bg-chlorophyll-light animate-pulse" />
          <span>AUTONOMOUS PLANETARY DEPLOYMENT</span>
        </div>

        <h2 className="font-serif font-black text-4xl sm:text-6xl md:text-7xl tracking-tight leading-[1.04]">
          The biosphere requires <br />
          <span className="italic font-normal text-chlorophyll-light">physical execution.</span>
        </h2>

        <p className="font-sans text-base sm:text-xl text-alabaster-300/80 max-w-2xl mx-auto leading-relaxed">
          Sovereign nations, multilateral climate institutions, and ecological stewards: deploy high-cadence aerial bio-swarms and permanent basaltic carbon crystallization across degraded territories.
        </p>

        <div className="flex flex-wrap items-center justify-center gap-4 pt-4">
          <MagneticButton
            href="https://t.me/TH157LECLAW"
            target="_blank"
            rel="noopener noreferrer"
            variant="emerald"
            size="lg"
            showArrow={true}
          >
            Commission Deployment Protocol
          </MagneticButton>

          <MagneticButton
            href="mailto:support@th157le.ru"
            variant="ghost"
            size="lg"
            showArrow={false}
            className="text-white border border-white/20 hover:bg-white/10"
          >
            Contact Scientific Council
          </MagneticButton>
        </div>

        <div className="pt-12 flex flex-wrap items-center justify-center gap-6 font-mono text-xs text-alabaster-400/50">
          <span>ZERO FOSSIL PENALTY</span>
          <span>•</span>
          <span>CRYPTOGRAPHIC ATTESTATIONS</span>
          <span>•</span>
          <span>10,000-YEAR PERMANENCE</span>
        </div>
      </div>
    </section>
  );
};
